import Icon from '@dtvgo/icon';
import './Toast.scss';
import { jsx, jsxs } from 'react/jsx-runtime';

var TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  NOTIFICATION: 'notification'
};
function Toast(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$subText = _ref.subText,
    subText = _ref$subText === void 0 ? '' : _ref$subText,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type;
  return /*#__PURE__*/jsx("div", {
    className: show ? "dtv-common-c-toast ".concat(className, " dtv-common-c-toast--").concat(type) : "dtv-common-c-toast disabled ".concat(className, " dtv-common-c-toast--").concat(type),
    children: /*#__PURE__*/jsxs("div", {
      className: "dtv-common-c-toast__body",
      children: [/*#__PURE__*/jsxs("div", {
        children: [type === TOAST_TYPES.SUCCESS && /*#__PURE__*/jsx(Icon, {
          className: "dtv-common-c-toast__logo",
          name: "success"
        }), type === TOAST_TYPES.ERROR && /*#__PURE__*/jsx(Icon, {
          className: "dtv-common-c-toast__logo",
          name: "error"
        }), type === TOAST_TYPES.NOTIFICATION && /*#__PURE__*/jsx(Icon, {
          className: "dtv-common-c-toast__logo",
          name: "exclamation-notification"
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "dtv-common-c-toast__text",
        children: [text, type === TOAST_TYPES.NOTIFICATION && /*#__PURE__*/jsx("div", {
          className: "dtv-common-c-toast__sub-text",
          children: subText
        })]
      })]
    })
  });
}

export { Toast as default };
//# sourceMappingURL=Toast.js.map
